var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"foot",attrs:{"data-flex":"cross:center main:center"},on:{"click":_vm.toUrl}},[_c('img',{attrs:{"src":require("../../assets/images/icon.png"),"alt":""}}),_c('div',[_vm._v("粤ICP备2024195512号")])])}
var staticRenderFns = []

export { render, staticRenderFns }